import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Modal, Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import FormInput from "../FormInput";
import useCaseDetailsContext from "../../hooks/useCaseDetailsContext";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import { getAllCheckList, getMasterFieldOfficerList } from "../../redux/actions/MasterActions";
import swal from 'sweetalert2';
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddCaseDocument = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const caseCtx = useCaseDetailsContext();
  const {
    pathname,
    actions,
    caseDetailsLists,
    loadingCaseDetails,
    errorsCaseDetails,
    changedCaseDetailsStatus,
    resetStatusType,
  } = caseCtx;
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    masterReducer: {
      masterCheckList,
      masterAllCheckSubLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (show && auth?.token)
    {
      dispatch(getAllCheckList(auth.token));
    }
  }, [show, auth?.token, dispatch]);
  

  useEffect(() => {
    setFormData({})
    if(id) {
      dispatch(actions.fetchCaseDetailsById(auth?.token, id, pathname));
    }
  }, [auth, id, pathname, dispatch, actions]);
  

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);

    const updatedFormData = {
      ...formData,
      remark: formData?.remark,
      case_id: id,
    };

    dispatch(actions.saveCaseDocuments(auth?.token, updatedFormData)).then(() => {
      setFormData({});
    });
  };

  
  useEffect(() => {
    if(id && caseDetailsLists && Object.keys(caseDetailsLists)?.length > 0) {
      setFormData({
      });
    }
  }, [caseDetailsLists]);


  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);


  const inputHandler = (e) => {
    const { name, files } = e.target;
  
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: e.target.value });
    }
  };


  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
  };


  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  
  useEffect(() => {
    if (changedCaseDetailsStatus?.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCaseDetailsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: resetStatusType });
    }
  }, [changedCaseDetailsStatus, dispatch, resetStatusType]);


  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{t("Case Check List")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsCaseDetails?.data?.message && (
          <div className="alert alert-danger">
            {errorsCaseDetails?.data?.message}
          </div>
        )}
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Form>
                  <Row>
                    <Col lg={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("Checklist")}</Form.Label>
                        <Select
                          options={masterCheckList}
                          values={masterCheckList?.filter(chec => chec?.id === formData?.checklist_id)}
                          name="checklist_id"
                          labelField={"name"}
                          valueField={"id"}
                          searchBy={"name"}
                          placeholder={t("Select Checklist")}
                          loading={loadingMaster}
                          onChange={(selectedData) => {
                            selectHandler2(selectedData[0]?.id, "checklist_id")
                          }}
                          styles={customSelectStyles}
                        />
                        
                        {errorsCaseDetails?.data?.checklist_id && (
                          <div className="invalid-feedback d-block">
                            <p className="text-danger">{errorsCaseDetails?.data?.checklist_id}</p>
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg={4}>
                      <FormInput
                        label={t("Remarks")}
                        type="text"
                        errors={errorsCaseDetails?.data}
                        value={formData.remark || ""}
                        name="remark"
                        onChange={inputHandler}
                        containerClass={"mb-3"}
                        placeholder={"Enter Remarks"}
                      />
                    </Col>

                    <Col lg={4} style={{ marginTop: "30px" }}>
                      <Button variant="outline-success" onClick={handleSubmit}>
                        Submit
                      </Button> 
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Table striped bordered hover className="mt-4">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Case Number</th>
                      <th>Name</th>
                      <th>Remark</th>
                      <th>File Type</th>
                      <th>File Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {caseDetailsLists?.length === 0 ? (
                      <tr>
                        <td colSpan="7">No data found</td>
                      </tr>
                    ) : (
                      <>
                        {caseDetailsLists?.map?.((doc, index) => (
                          <tr key={doc.id}>
                            <td>{index + 1}</td>
                            <td>{doc.claim_number}</td>
                            <td>{doc.name}</td>
                            <td>{doc.remark}</td>
                            <td>{doc.file_type}</td>
                            <td>
                              <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                {doc.file_name}
                              </a>
                            </td>
                            <td>
                              <Button variant="danger" size="sm">
                                Delete
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </Table>
                </Card.Body>
            </Card>
          </Col>
        </Row>
        <div className="d-flex justify-content-center">
          <Button variant="dark" onClick={onHide}>
            {t("Close")}
          </Button>
        </div>
      </Modal.Body>
      {loadingCaseDetails && <Preloader />}
    </Modal>
  );
};

export default AddCaseDocument;
